export default __webpack_public_path__ + "static/media/map-marker.be42874e.svg";